import React from "react";
import RegularText from "../common/_RegularText";
import {Button, Modal} from "../common";
import styles from "../common/_Modal/_Modal.module.scss";

const DenyRequestModal = ({onYes, show, setShow}) => {
    return <Modal header={"requestDetails.modal.deny.header"} show={show} setShow={setShow} handleClose={() => setShow(false)}>
        <RegularText text="requestDetails.modal.deny.message"/>
        <Modal.Footer>
            <Button label={"requestDetails.modal.deny.noButton"} variant={"secondary"}
                    onClick={() => setShow(false)}/>
            <Button label={"requestDetails.modal.deny.yesButton"} variant={"danger"}
                    onClick={() => onYes()} className={styles.submitButton}/>
        </Modal.Footer>
    </Modal>
};
export {DenyRequestModal};